import type { AvailableResource, ResourceState } from '../types';

const TONE: Record<ResourceState, { pill: string; text: string }> = {
  free: { pill: 'free', text: 'Free' },
  am_free: { pill: 'half', text: 'Morning free' },
  pm_free: { pill: 'half', text: 'Afternoon free' },
  taken: { pill: 'taken', text: 'Taken' },
  blocked: { pill: 'blocked', text: 'Unavailable' },
  reserved: { pill: 'blocked', text: 'Reserved' },
};

interface Props {
  resources: AvailableResource[];
  selectedId: string | null;
  onSelect: (resource: AvailableResource) => void;
  /** Hides everything already gone, which is most of a busy Wednesday. */
  onlyFree: boolean;
}

export function ResourceList({ resources, selectedId, onSelect, onlyFree }: Props) {
  const visible = onlyFree
    ? resources.filter((resource) => resource.bookable || resource.mine)
    : resources;

  if (visible.length === 0) {
    return (
      <div className="center">
        <p>Nothing free here on this day.</p>
        <p className="muted">Try another floor, or check back closer to the morning.</p>
      </div>
    );
  }

  return (
    <div className="list">
      {visible.map((resource) => {
        const tone = resource.mine
          ? { pill: 'mine', text: 'Yours' }
          : TONE[resource.state];
        return (
          <button
            key={resource.id}
            className="list-row"
            aria-pressed={resource.id === selectedId}
            disabled={!resource.bookable && !resource.mine}
            onClick={() => onSelect(resource)}
            style={
              resource.id === selectedId
                ? { background: 'var(--accent-soft)' }
                : undefined
            }
          >
            <span className="label">{resource.label}</span>
            <span className="meta">
              {resource.zone ?? ''}
              {resource.heldBy ? ` · ${resource.heldBy}` : ''}
            </span>
            <span className={`pill ${tone.pill}`}>{tone.text}</span>
          </button>
        );
      })}
    </div>
  );
}
